import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import deviceLanguage from './deviceLanguage';
import { getTranslationOverrides } from './translationOverrides';
import { LANGUAGE_NAME_OVERRIDES } from './languages';

const resources = {
  en: { translation: require('./en-GB.json') },
  cy: { translation: require('./cy-GB.json') },
};

const fallback = { languageTag: 'en' };
const { languageTag } = deviceLanguage || fallback;

// i18next uses short language codes for resources (e.g. 'en', 'cy').
// Ensure initial language uses the short form so lookups hit the correct resource bundle.
const initialLng = (languageTag && languageTag.split && languageTag.split('-')[0]) || 'en';

i18n.use(initReactI18next).init({
  resources,
  // Use a single namespace 'translation' (our resources are under that namespace)
  ns: ['translation'],
  defaultNS: 'translation',
  lng: initialLng,
  fallbackLng: 'en',
  // Logging the full resource bundle is very expensive on Android and can
  // contribute to long main-thread stalls.
  debug: false,
  // Avoid async init scheduling during startup; in some bridgeless configurations
  // the microtask queue can be unavailable early, causing fatal errors.
  initImmediate: false,
  react: {
    useSuspense: false,
  },
  interpolation: {
    escapeValue: false,
  },
});

// Apply translation overrides for locally bundled languages.
// Remote languages get overrides applied in translationLoader.ts.
for (const lang of Object.keys(resources)) {
  const overrides = getTranslationOverrides(lang);
  if (overrides) {
    i18n.addResourceBundle(lang, 'translation', overrides, true, true);
  }
  i18n.addResourceBundle(lang, 'translation', LANGUAGE_NAME_OVERRIDES, true, true);
}

export const i18next = i18n;
